import FixAlert from './MyAlert.vue'

export default {
  install (Vue, { maximumAlerts, alertsTheme }, store) {
    // Register module when installing the plugin
    store.registerModule('alertModule', alertModule)

    // If the option was passed set the maximum alerts in the module
    if (maximumAlerts) {
      store.dispatch('setMaximumAlerts', maximumAlerts)
    }

    // If the option was passed set the alerts theme in the module
    if (alertsTheme) {
      store.dispatch('setAlertsTheme', alertsTheme)
    }

    // Register the Alert component globally
    Vue.component('FixAlert', FixAlert)

    // Add createAlert to the Vue prototype
    Vue.prototype.$createAlert = (options) => {
      store.dispatch('createAlert', options)
    }

    // Add removeAlert to the Vue prototype
    Vue.prototype.$removeAlert = (id) => {
      store.dispatch('removeAlert', id)
    }

    // Retry passed action if a method was passed
    Vue.prototype.$retryAction = (id) => {
      return store.dispatch('retryAction', id)
    }
  }
}

const alertModule = {
  state: {
    alertList: [],
    maximumAlerts: 3,
    alertsTheme: {}
  },
  mutations: {
    // Create alert up to the maximum alert
    CREATE_ALERT (state, alertObject) {
      const alertList = state.alertList
      if (alertList.length > state.maximumAlerts - 1) {
        alertList.shift()
      }
      alertList.push(alertObject)
    },

    // Dismiss alert automatically if duration was passed
    DISMISS_ALERT (state, alertObject) {
      const alertList = state.alertList
      if (alertList.length && alertObject.duration) {
        setTimeout(() => {
          this.dispatch('removeAlert', alertObject.id)
        }, alertObject.duration)
      }
    },

    // Find the alert by ID and remove it
    REMOVE_ALERT (state, id) {
      const alertList = state.alertList
      if (alertList.length) {
        const foundAlert = alertList.indexOf(alertList.find(alert => alert.id === id))
        alertList.splice(foundAlert, 1)
      }
    },

    // Find the alert and retry the action that was passed
    RETRY_ACTION (state, id) {
      const alertList = state.alertList
      if (alertList.length) {
        const { action } = alertList.find(alert => alert.id === id)
        action.method(id, ...action.params)
      }
    },

    // If passed as an option, set the maximum of alerts
    SET_MAXIMUM_ALERTS (state, maximum) {
      state.maximumAlerts = maximum
    },

    // If passed as an option, set the alerts theme
    SET_ALERTS_THEME (state, theme) {
      state.alertsTheme = { ...theme }
    }
  },
  actions: {
    // Create the alert object and commit the mutation, if duration was passed
    // commit the dismiss alert mutation
    createAlert ({ commit }, options) {
      const alertObject = { ...options }
      alertObject.visible = true
      alertObject.id = guidGenerator()
      commit('CREATE_ALERT', alertObject)
      if (alertObject.duration) {
        commit('DISMISS_ALERT', alertObject)
      }
    },

    // Commit the remove alert mutation
    removeAlert ({ commit }, id) {
      commit('REMOVE_ALERT', id)
    },

    // Commit the retry action mutation
    retryAction ({ commit }, id) {
      commit('RETRY_ACTION', id)
    },

    // Commit the set maximum alerts mutation
    setMaximumAlerts ({ commit }, option) {
      commit('SET_MAXIMUM_ALERTS', option)
    },

    // Commit the set maximum alerts mutation
    setAlertsTheme ({ commit }, theme) {
      commit('SET_ALERTS_THEME', theme)
    }
  }
}

const guidGenerator = () => {
  const S4 = () => {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }
  return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4())
}
